import { request } from './request'

export const getUserList = () => {
    const url = '/ocean/api/v1/shop/user/list'
    return request({
        method: 'get',
        url: url
    })
}
export const getStockTable = (data) => {
    const url = '/ocean/api/v1/product/stock/list'
    return request({
        method: 'post',
        url: url,
        data
    })
}

export const addStockOrder = (data) => {
    const url = '/ocean/api/v1/product/stock/addOrUpdate'
    return request({
        method: 'post',
        url: url,
        data
    })
}

export const addAndCheckStockOrder = (data) => {
    const url = '/ocean/api/v1/product/stock/addandcheck'
    return request({
        method: 'post',
        url: url,
        data
    })
}

export const checkStockOrder = (data) => {
    const url = `/ocean/api/v1/product/stock/check/${data}`
    return request({
        method: 'put',
        url: url
    })
}

export const closeStockOrder = (data) => {
    const url = '/ocean/api/v1/product/stock/close'
    return request({
        method: 'put',
        url: url,
        data
    })
}

export const getStockOrderDetail = (data) => {
    const url = `/ocean/api/v1/product/stock/select/one/${data}`
    return request({
        method: 'get',
        url: url
    })
}

export const exportStockOrder = (data) => {
    const url = '/ocean/api/v1/product/stock/detail/export'
    return request({
        method: 'post',
        url: url,
        responseType: 'blob',
        data
    })
}

export const getStockOrderList = (data) => {
    const url = '/ocean/api/v1/product/stock/detail/list'
    return request({
        method: 'post',
        url: url,
        data
    })
}

export const getSkuList = (data) => {
    const url = '/ocean/api/v1/product/stock/sku'
    return request({
        method: 'post',
        url: url,
        data
    })
}

export const getImportTemplate = (data) => {
    const url = '/ocean/api/v1/product/stock/detail/getImportTemplate'
    return request({
        method: 'post',
        url: url,
        data
    })
}

export const importStockOrder = (data) => {
    const url = '/ocean/api/v1/product/stock/import'
    return request({
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        url: url,
        data
    })
}

// 商家-库存概览规则设置查询
export const getStockRule = () => {
  const url = '/ocean/api/v1/merchant/getInventorySetting'
  return request({
    method: 'GET',
    url: url
  })
}

// 商家-库存概览规则设置
export const saveStockRule = (data) => {
  const url = '/ocean/api/v1/merchant/saveOrUpdate'
  return request({
    method: 'POST',
    url: url,
    data
  })
}
